<template>
	<div class="fd-form-body" :class="clazz" :style="flexStyle" v-if="visible">
		<template v-for="item in body.items">
			<component :is="componentOfPart(item)" :part="partRef(item)" :data="localData" :readonly="ro" :viewmode="vm"></component>
		</template>
	</div>
</template>

<script setup lang="ts">
import useContainer, { type ContainerProps, containerProps } from "./Container";
import {computed, defineProps} from "vue";
import type { Body } from "@t/fd/layout/Body";

const untypedProps = defineProps({
	...containerProps,
});

const props = untypedProps as ContainerProps;

const body = computed<Body>(() => props.part as Body);

const { componentOfPart, partRef, localData, ro, vm, visible, clazz, style } = useContainer(props);

const flexStyle = computed(() => {
    const styles = [{
        justifyContent: body.value.justify ? body.value.justify : "flex-start",
        alignItems: body.value.align ? body.value.align : "stretch",
    }, style.value];
    if (body.value.space) {
        styles.push({ gap: body.value.space });
    }
    return styles;
});
</script>

<style>
.fd-form-body {
	display: flex;
	flex-direction: column;
	row-gap: var(--gap);
}
</style>
